import env from "react-dotenv";
export const CONF_UTIL = {
    UTIL_MANAGEMENT_HOST: process.env.REACT_APP_URL_SISWA_BE, //prod
    // UTIL_MANAGEMENT_HOST: "https://k8s-be.eduprime.co.id/api", //prod
    // UTIL_MANAGEMENT_HOST: 'https://backend.eduprime.co.id/api', //prod
    // UTIL_MANAGEMENT_HOST: 'http://localhost:8090/api', //server-dev

    UTIL_RESET_TIMER_SISWA: "/get-timer/",
    UTIL_RESET_PP_BLANK: "/invalidate/redis/cache/student_program?id=",
    UTIL_GET_LIVE_REPORT: "/get_analysis/",
    UTIL_INVALIDATE_REDISL: "/invalidate/redis/cache",

    // REPORTING SNMPTN
    SNMPTN_FETCH_REPORT_SISWA: "/raporfrompsep",
    REPORT_SISWA_AKM: "akm/report/",

    UTIL_FETCH_PROVINSI: "/getprovinsi",
    UTIL_FETCH_KABUPATEN_BY_ID_PROVINSI: "/kab_kota/",

    SUCCESS_ERROR_CODE: "200",
    ID_ROLE_ADMIN_SEKOLAH: 9,
    ID_ROLE_GURU: 10,

    // SNBP
    SNBP_GET_NILAI: "snmptn/nilaimatapelajaran?idSiswa=",

    // Province
    LIST_PROVINCE: "provinsi",

    // REPORT ENSA
    REPORT_ENSA_SISWA: "/ensa/report/siswa",
    REPORT_ENSA_SEKOLAH: "/ensa/report/sekolah",
    REPORT_ENSA_DINAS: "/ensa/report/dinas",

    // CACHE
    CACHE_REPORT_SISWA: "/invalidate/redis/users/",
};
